module.exports = __webpack_public_path__ + "static/media/tedx.96e5abca.jpeg";